var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["help/templates/email-unsubscribe.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/form-validation.j2", false, "help/templates/email-unsubscribe.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayGeneralErrors")) {
var t_4 = t_1.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_4);
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_5 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_5);
if(t_1.hasOwnProperty("validatedField")) {
var t_6 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_6);
output += "\n\n<div class=\"dom-email-unsubscribe\">\n\n    <form novalidate action=\"#\" method=\"post\" class=\"c-form js-email-unsubscribe-form\">\n\n        ";
if((lineno = 6, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["help.emailUnsubscribe.msgs.emailToUnsubscribe"]))) {
output += "\n\n            ";
output += runtime.suppressValue((lineno = 8, colno = 33, runtime.callWrap(t_4, "displayGeneralErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"emailUnsubscribe")),"msgs")),"emailToUnsubscribe")])), env.opts.autoescape);
output += "\n\n        ";
;
}
output += "\n\n        ";
if((lineno = 12, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["help.emailUnsubscribe.error"]))) {
output += "\n\n            <div class=\"c-form__field has-error\">\n\n                <div class=\"c-form-block\">\n\n                    <p class=\"c-form-block__p\">\n\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"errorLocalization")),"ERROR_UNSUBSCRIBE_" + "" + runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"emailUnsubscribe")),"responseData")),"entity")),"code")), env.opts.autoescape);
output += "\n\n                    </p>\n\n                </div>\n\n            </div>\n\n        ";
;
}
else {
if((lineno = 28, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["help.emailUnsubscribe.unsubscribeSuccessful"])) == true) {
output += "\n\n            <div class=\"c-form__field has-success\">\n\n                <div class=\"c-form-block\">\n\n                    <p class=\"c-form-block__p\" data-qa-unsubscribe-confirm>\n\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"chromeLocalization")),"help_unsubscribe_success"), env.opts.autoescape);
output += "\n\n                    </p>\n\n                </div>\n\n            </div>\n\n        ";
;
}
;
}
output += "\n\n        <div class=\"c-form__subtitle\">\n\n            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"chromeLocalization")),"help_unsubscribe_form_message"), env.opts.autoescape);
output += "\n\n        </div>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12 o-medium--8 o-large--5 u-no-gutters\">\n\n                <div class=\"c-form__field\">\n\n                    <label for=\"text-1\" class=\"c-form__label\">\n\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"chromeLocalization")),"help_unsubscribe_form_label"), env.opts.autoescape);
output += "\n\n                    </label>\n\n                    <input type=\"email\" class=\"c-form__email js-email-unsubscribe-email-address\" name=\"emailToUnsubscribe\" maxlength=\"255\" data-parsley-type=\"email\" data-parsley-required required ";
output += runtime.suppressValue((lineno = 64, colno = 211, runtime.callWrap(t_6, "validatedField", context, ["ERROR_UNSUBSCRIBE_INVALID_EMAIL"])), env.opts.autoescape);
output += " data-qa-unsubscribe-email-field />\n\n                </div>\n\n            </div>\n\n        </div>\n\n        <div class=\"o-row\">\n\n            <div class=\"o-column o-extra-small--12 o-medium--8 o-large--5 u-no-gutters\">\n\n                <div class=\"c-form__field\">\n\n                    <button aria-label=\"Submit\" aria-labelledby=\"unsubscribe-submit_hint\" class=\"c-button-primary\" type=\"submit\" name=\"submit\" data-qa-email-unsubscribe-button>\n\n                        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"chromeLocalization")),"help_unsubscribe_form_submit"), env.opts.autoescape);
output += "\n\n                    </button>\n\n                    <div class=\"c-form-hint\">\n\n                        <p class=\"c-form-hint__p\" id=\"unsubscribe-submit_hint\">\n\n                            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"localizations")),"containers")),"chromeLocalization")),"help_unsubscribe_form_hint"), env.opts.autoescape);
output += "\n\n                        </p>\n\n                    </div>\n\n                </div>\n\n            </div>\n\n        </div>\n\n    </form>\n\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["help/templates/email-unsubscribe.j2"] , dependencies)